import { useState, useEffect } from "react";
import { traerHorariosAtencion } from "../../apiClient/rutes/turnos";

export function useHorariosPrestador(prestadorCodigo, usuario, urlAxioPP) {
  const [horariosPrestador, setHorariosPrestador] = useState(null);
  const [cargandoHorarios, setCargandoHorarios] = useState(false);
  const [errorHorarios, setErrorHorarios] = useState(null);

  useEffect(() => {
    const baseUrl = urlAxioPP || process.env.REACT_APP_API_URL;
    if (!prestadorCodigo || !usuario || !baseUrl) return;
    setCargandoHorarios(true);
    setErrorHorarios(null);
    traerHorariosAtencion(prestadorCodigo, usuario, baseUrl)
      .then((res) => {
        setHorariosPrestador(res.horarios);
      })
      .catch((err) => {
        setErrorHorarios(err.message || "Error al cargar horarios");
        setHorariosPrestador(null);
      })
      .finally(() => setCargandoHorarios(false));
  }, [prestadorCodigo, usuario, urlAxioPP]);

  return { horariosPrestador, cargandoHorarios, errorHorarios };
}
